import { css } from '@emotion/react'
import { EmotionTheme } from '../emotionTheme'

export const globalStyles = (theme: EmotionTheme) =>
  css({
    '.ant-btn-primary': {
      backgroundColor: theme.grey7,
      background:
        'linear-gradient(180deg, rgba(255,255,255,.8) 0%, rgba(255,255,255,0) 100%),' +
        theme.grey7,
      color: theme.grey1,
      border: 0,
      boxShadow:
        'inset -1px 1px 0 rgb(16 22 26 / 10%), inset 0 0 0 1px rgb(16 22 26 / 20%)',
      '&:hover': {
        backgroundColor: theme.grey6 + '!important',
        color: theme.grey2,
        background:
          'linear-gradient(180deg, rgba(255,255,255,.5) 0%, rgba(255,255,255,0) 100%),' +
          theme.grey6 +
          '!important',
        boxShadow:
          'inset -1px 1px 0 rgb(16 22 26 / 10%), inset 0 0 0 1px rgb(16 22 26 / 20%)',
      },
      '&:focus, &:active': {
        backgroundColor: theme.grey6 + '!important',
        color: theme.grey2,
        background:
          'linear-gradient(180deg, rgba(255,255,255,.5) 0%, rgba(255,255,255,0) 100%),' +
          theme.grey6 +
          '!important',
        boxShadow: `inset -1px 1px 0 ${theme.primaryColor}, inset 0 0 0 1px ${theme.primaryColor} !important`,
      },

      '&:disabled': {
        color: theme.grey5,
        background: theme.grey3,
        border: `1px solid ${theme.grey5}`,
        boxShadow: 'none',
        textShadow: 'none',
      },
    },
    '.hide-on-mobile': {
      '@media (max-width: 600px)': {
        display: 'none !important',
      },
    },
    '.mdxeditor-popup-container': {
      zIndex: '1001 !important',
      button: {
        lineHeight: 1.5715,
        position: 'relative',
        display: 'inline-block',
        fontWeight: 400,
        whiteSpace: 'nowrap',
        textAlign: 'center',
        backgroundImage: 'none',
        border: '1px solid transparent',
        boxShadow: '0 2px 0 rgba(0, 0, 0, 0.015)',
        cursor: 'pointer',
        transition: 'all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)',
        userSelect: 'none',
        touchAction: 'manipulation',
        height: 32,
        padding: '4px 15px',
        fontSize: 14,
        borderRadius: 3,
        color: '#3E3D40',
        borderColor: '#D9DADB',
        background: '#fff',
      },
      'button[type="submit"]': {
        background:
          'linear-gradient(180deg, rgba(255, 255, 255, .8) 0%, rgba(255, 255, 255, 0) 100%), #ECEDED',
        color: '#3E3D40',
        border: 0,
        boxShadow:
          'inset -1px 1px 0 rgb(16 22 26 / 10%), inset 0 0 0 1px rgb(16 22 26 / 20%)',
      },
    },
  })
